<template>
    <div class="quarter-card plan-quarter-card">
        <div class="lunar-calendar">
            <div class="gl clearfix">
			<span class="gl-quarter">
			<span class="quarter" v-bind:class="{'current': currentQuarter}">{{ data.name}}</span>
                   <span class="current-quarter" v-bind:style="{ display: activeStatus}">（本季度）</span>
			</span>
                <span class="gl-year">{{ data.year}}</span>
            </div>
        </div>
        <div class="card-plan-wrap">
            <div class="quarter-plan plan-detail" style="position: relative;">
                <div class="line-height-28 font14" v-if="quarterPlan==null">季度计划:<span class="color999" style="font-size: 12px;">(未制定)</span>
                </div>
                <h5 v-if="quarterPlan!=null" class="ellipsis calendar-limit-title month-plan-title" v-bind:title="quarterPlan.title">
                    <router-link :to="{ name: 'planmobileinfo' , params: { id:quarterPlan.id} }">
                        {{quarterPlan.title}}
                    </router-link>
                                              <span   :class="rateClass(quarterPlan.rate_of_progress)"
                                              style="position: absolute;right: 3%;float: right;font-weight: bold;" title="计划进度">{{
                                                Math.floor(quarterPlan.rate_of_progress * 100) / 100
                                            }}%</span>

                </h5>

                <router-link class="click-new-create" v-if="quarterPlan==null  && isOwner"
                             :to="{ name: 'newmobileplan' , params: { planType: 'quarter' ,dateValue:data.year+'-'+data.months[0]+'-01'} }">
                    <span>点击新建</span>
                </router-link>
            </div>
            <div class="month-plan">
                <ul v-for="(month,index) in monthsPlan"
                    :key="index">
                    <li class="single-month-wrap  plan-detail" v-bind:class="{currentweek:month.isCurrent}">
                        <div class="single-month">
                            <div class="has-not-plan" v-if="month.plan==null">
                                <div class="month-num-title calendar-limit-title">
                                    {{month.isCurrent?'本':month.month}}月:
                                    <h5 class="month-title ellipsis color999" style="font-size: 12px;">（未制定）</h5>
                                    <router-link class="click-new-create" v-if="isOwner"
                                                 :to="{ name: 'newmobileplan' , params: { planType: 'month',dateValue:data.year+'-'+month.month,startDate:data.year+'-'+month.month+'-01'  } }">
                                        点击新建
                                    </router-link>
                                </div>
                            </div>
                            <div class="has-plan" v-if="month.plan!=null">
                                <div class="month-num-title calendar-limit-title">
                                    {{month.isCurrent?'本':month.month}}月:
                                    <h5 class="month-title ellipsis" v-bind:title="month.plan.title">
                                        <router-link :to="{ name: 'planmobileinfo' , params: { id:month.plan.id,ref_page:'mobileplan'} }">
                                            {{month.plan.title}}
                                        </router-link>
                                        <span  :class="rateClass(month.plan.rate_of_progress)"
                                              style="position: absolute;right: 3%;float: right;font-weight: bold" title="计划进度">{{
                                                Math.floor(month.plan.rate_of_progress * 100) / 100
                                            }}%</span>

                                    </h5>
                                </div>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script type="text/javascript">
    import {mapState, mapGetters, mapActions} from 'vuex'

    export default {
        props: {
            data: {
                type: Object,
                selectQuarter: "",
                require: true
            }
        },
        data: function () {
            return {
                 isOwner:true,
            }
        },
        computed: {
            ...mapState({
                login_user_id: state => state.loginState.user_info.id,
                my_plans: state => state.plan.my_plans,
            }),
            ...mapGetters({
                display_plans: 'plan/display_plans',
            }),
            quarterPlan: function () {
                let p = []
                for (var i = 0; i < this.my_plans.length; i++) {
                    if (this.my_plans[i].plan_type === "quarter" && (new Date(this.my_plans[i].open_time)).getFullYear() == this.data.year && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) == (this.data.months[0])) {
                        p.push(this.my_plans[i])
                        break
                    }
                }
                return p.length > 0 ? p[0] : null
            },
            monthsPlan: function () {
                let months = [];
                let dataNow = new Date()
                for (var mm = 0; mm < this.data.months.length; mm++) {
                    let month = new Object();
                    month.month = this.data.months[mm]
                    month.year=this.data.year
                    month.isCurrent = false
                    if (dataNow >= (new Date(month.year+'-'+month.month+'-01')) && dataNow <(new Date(month.year+'-'+(month.month+1)+'-01')))
                        month.isCurrent = true

                    for (var i = 0; i < this.my_plans.length; i++) {
                        if (this.my_plans[i].plan_type === "month" && (new Date(this.my_plans[i].open_time)).getFullYear() == this.data.year && ((new Date(this.my_plans[i].open_time)).getMonth() + 1) ==this.data.months[mm]) {
                            month.plan = this.my_plans[i];
                        }
                    }
                    months.push(month);
                }
                return months;
            },
            currentQuarter: function () {
                let theMonth = (new Date()).getMonth() + 1;
                let quarterIdx = 1;
                if (theMonth <= 3) {
                    quarterIdx = 1
                } else if (theMonth <= 6) {
                    quarterIdx = 2
                } else if (theMonth <= 9) {
                    quarterIdx = 3
                } else if (theMonth <= 12) {
                    quarterIdx = 4
                }
                return this.data.quarter == quarterIdx && this.data.year== (new Date()).getFullYear()? true : false;
            },
            activeStatus: function () {
                let theMonth = (new Date()).getMonth() + 1;
                let quarterIdx = 1;
                if (theMonth <= 3) {
                    quarterIdx = 1
                } else if (theMonth <= 6) {
                    quarterIdx = 2
                } else if (theMonth <= 9) {
                    quarterIdx = 3
                } else if (theMonth <= 12) {
                    quarterIdx = 4
                }
                return this.data.quarter == quarterIdx && this.data.year== (new Date()).getFullYear()? "" : "none";
            },
        },
        methods: {
            ...mapActions({}),
                                    rateClass: function(rate){
           if(rate==0) return 'undoRate';
            if(rate==100) return 'finishRate';
            else return 'ondoRate';
        },
        },
        mounted() {
          let  uid=this.$route.query.uid;
             if(uid) {
                 if(uid!=this.login_user_id){
                    this.isOwner=false;
                 }
             }
        }
    }
</script>

<style type="text/css" scoped>
        .undoRate{
        color: red;
    }
    .finishRate{
        color: #0b2e13;
    }
        .ondoRate{
        color: #004488;
    }
    .quarter-card {
        float: left;
        /*margin-right: 40px;*/
        width: 100%;
        background-color: #fff;
        box-shadow: 0 5px 5px 0px #d9d9d9;
        overflow: hidden;
        position: relative;
        margin-bottom: 10px;
    }

    .quarter-card .lunar-calendar {
        padding: 15px;
        color: #fff;
        border-bottom: 1px solid #dedede;
        border-top: 1px solid #dedede;
    }

    .quarter-card .lunar-calendar .gl-month {
        float: left;
        font-size: 30px;
        color: #666;
    }

    .quarter-card .lunar-calendar .gl-year {
        float: right;
        font-size: 18px;
        color: #999;
        margin-top: 5px;
    }

    .quarter-card .card-plan-wrap .quarter-plan {
        padding: 10px 0;
        height: 45px;
        padding-left: 15px;
        border-bottom: 1px solid #ededed;
    }

    .calendar-limit-title {
        width: 65%;
    }

    .quarter-card .quarter-plan-title {
        margin: 0;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        font-weight: normal;
    }

    .quarter-card .quarter-plan-title {
        margin: 0;
        font-size: 14px;
        color: #333;
        line-height: 24px;
        font-weight: normal;
    }

    .quarter-card .quarter-plan .quarter-ver-time {
        line-height: 20px;
    }

    .quarter-card .last-modify {
        float: right;
        color: #999999;
        margin-right: 6.25%;
    }

    .quarter-card a.click-look.has-time {
        top: 30%;
    }

    .quarter-card .card-plan-wrap .month-plan {
        width: 100%;
    }

    .single-week-wrap {
        margin-top: -1px;
    }

    .quarter-card .month-plan .single-week-wrap {
        position: relative;
        padding: 0;
    }

    .quarter-card .card-plan-wrap .month-plan ul .single-month-wrap {
        margin-left: -1px;
        margin-right: -1px;
        cursor: pointer;
        display: block;
    }

    .single-month {
        margin-left: 25px;
        border-bottom: 1px solid #ededed;
    }

    .month-plan ul .has-plan {
        padding: 7px 0 7px 0;
    }

    .quarter-card .has-not-plan {
        position: relative;
        padding: 7px 0 7px 0;
        width: 100%;
    }

    .lunar-calendar .gl-quarter {
        float: left;
        font-size: 20px;
        color: #666;
    }

    .gl-quarter .current-quarter {
        color: #999;
        font-size: 14px;
        vertical-align: 1px;
    }

    .gl-quarter .quarter.current {
        color: #222;
        font-weight: bold;
    }

    .quarter-card.current .gl-quarter .quarter {
        color: #222;
        font-weight: bold;
    }

    .gl-quarter .current-quarter {
        color: #999;
        font-size: 14px;
        vertical-align: 1px;
    }

    .font14 {
        font-size: 14px;
    }

    .line-height-42 {
        line-height: 42px;
    }

    .color999 {
        color: #999 !important;
    }

    a.click-new-create {
        position: absolute;
        right: 6.25%;
        color: #29e;
        font-size: 12px;
        margin-top: -6px;
        line-height: 12px;
        top: 50%;
    }

    .has-not-plan span {
        color: #999;
    }

    .quarter-plan:hover > a.click-new-create {
        display: inline-block;
    }

    .has-not-plan:hover > a.click-new-create {
        display: inline-block;
    }
    .month-num-title:hover > a.click-new-create {
        display: inline-block;
    }
    .month-title {
        margin-left: 15px;
        font: inherit;
        font-size: 18px;
    }
    .has-not-plan .month-title{
        font-weight: normal;
    }
    .calendar-limit-title {
        width: 100%;
        white-space: nowrap;
        word-break: keep-all;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .ellipsis {
        white-space: nowrap;
        word-break: keep-all;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .currentweek {
        background-color: #fffccc;
    }
</style>
